'use strict';
import * as $j_app$002elocalization$002e$002dL18n$0024 from "./app.localization.-L18n$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_components_instances$package$$anon$5(x$1$11) {
  this.axn = null;
  this.axn = x$1$11;
}
export { $c_Lapp_components_instances$package$$anon$5 as $c_Lapp_components_instances$package$$anon$5 };
$p = $c_Lapp_components_instances$package$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_components_instances$package$$anon$5;
/** @constructor */
function $h_Lapp_components_instances$package$$anon$5() {
}
export { $h_Lapp_components_instances$package$$anon$5 as $h_Lapp_components_instances$package$$anon$5 };
$h_Lapp_components_instances$package$$anon$5.prototype = $p;
$p.bXm = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().fe($j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().aV8.bD(this.axn));
});
var $d_Lapp_components_instances$package$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_components_instances$package$$anon$5, "app.components.instances$package$$anon$5", ({
  z2: 1,
  Vl: 1
}));
export { $d_Lapp_components_instances$package$$anon$5 as $d_Lapp_components_instances$package$$anon$5 };
//# sourceMappingURL=app.components.instances$package$$anon$5.js.map
